import {ComponentTDO} from "./Models/ApiModels";

export const SORTING_KEY = 'app_sort';
export const FILTER_KEY = 'app_filter';

export class AppRouting {
    public static Index = '/';
    public static Tickets = '/tickets';
    public static Tasks = '/tasks';
    public static Logs = '/logs';
}

export class ApiURL {
    public static Users = '/users';
    public static MaintenanceTasks = '/service/maintenance/tasks';
    public static Organizations = '/equipment/organizations';
    public static Regions = '/equipment/regions';
    public static Sites = '/equipment/sites';
    public static Devices = '/equipment/devices';
    public static Tickets = '/service/support/tickets';
    public static Permissions = '/permissions';
}

export const IMAGE_TYPE: string[] = ['.png', '.jpg', '.jpeg', '.bmp', '.tif'];
export const DOCUMENT_TYPE: string[] = ['.pdf'];
export const ALLOW_FILE_TYPES: string[] = [...IMAGE_TYPE, ...DOCUMENT_TYPE];
export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const TEXTAREA_MAX_LENGTH = 500;
export const CHAT_MAX_LENGTH = 5000;

export const CLASSIFICATION = [
    {id: "ControlSystems", name: "Control Systems"},
    {id: "General", name: "General"},
    {id: "Mechanical", name: "Mechanical"},
    {id: "ProcessTechnology", name: "Process Technology"}
];

export const DEVICE_COMPONENTS: ComponentTDO[] = [
    {id: "1", name: "Inlet hopper"},
    {id: "2", name: "Inlet screw"},
    {id: "3", name: "Side feeder"},
    {id: "4", name: "Compounder"},
    {id: "5", name: "Connecting tube"},
    {id: "6", name: "Discharge single screw"},
    {id: "7", name: "Conical Discharge pump"},
    {id: "8", name: "Pelletizing system"},
    {id: "9", name: "Cutting device"},
    {id: "10", name: "Round die"},
    {id: "11", name: "Strand die"},
    {id: "12", name: "Gravimetric / Volumetric dosing unit "},
    {id: "13", name: "Liquid dosing unit"},
    {id: "14", name: "Collecting screw"},
    {id: "15", name: "Gear Melt pump"},
    {id: "16", name: "Screen changer"},
    {id: "17", name: "Underwater pelletizer"},
    {id: "18", name: "Heating/ Cooling unit"},
    {id: "19", name: "Vacuum system"},
    {id: "20", name: "Control equipment"},
    {id: "0", name: "Other / Not in list"},
];
export enum Roles {
    GlobalAdmin = 'GlobalAdmin',
    Admin = 'Admin',
    User = 'User',
    GlobalSupport = 'GlobalSupport',
}